export default __webpack_public_path__ + "static/media/auto-fix-high-light.0ed200a9.svg";